import React from "react";

export const StyledText = ({
  className,
  color,
  children,
  ...rest
}: React.HTMLAttributes<HTMLElement>) => {
  return (
    <p className={className} style={{ color: color }} {...rest}>
      {children}
    </p>
  );
};
